import ScrollReveal from '@/pages/home/components/ScrollReveal';

const positions = [
  { title: 'Android 开发工程师', dept: '技术部', type: '全职', location: '北京' },
  { title: 'iOS 开发工程师', dept: '技术部', type: '全职', location: '北京' },
  { title: '漫画编辑', dept: '内容部', type: '全职', location: '上海' },
  { title: '内容运营专员', dept: '内容部', type: '全职', location: '上海' },
  { title: 'UI/UX 设计师', dept: '设计部', type: '全职', location: '深圳' },
  { title: '社区运营', dept: '运营部', type: '全职', location: '北京' },
  { title: '市场推广经理', dept: '市场部', type: '全职', location: '深圳' },
  { title: '产品经理', dept: '产品部', type: '全职', location: '北京' },
];

const perks = [
  { icon: 'ri-cup-line', title: '弹性工作', desc: '弹性上下班，拒绝无效内卷。' },
  { icon: 'ri-book-open-line', title: '漫画自由', desc: '全员免费会员，看漫画不花钱。' },
  { icon: 'ri-heart-3-line', title: '完善保障', desc: '五险一金、带薪年假、年度体检。' },
  { icon: 'ri-rocket-line', title: '快速成长', desc: '扁平化管理，与优秀的人一起成长。' },
];

export default function Careers() {
  return (
    <div className="min-h-screen bg-white pt-20">
      <section className="px-4 md:px-8 lg:px-16 xl:px-24 py-20 md:py-28">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="text-center mb-16">
              <span className="inline-block px-4 py-1.5 rounded-full bg-pink-50 text-pink-600 text-sm font-medium mb-4">
                加入我们
              </span>
              <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                与热爱漫画的人同行
              </h1>
              <p className="text-gray-500 text-lg max-w-2xl mx-auto">
                天天漫画正在快速成长，我们欢迎每一个热爱漫画、心怀梦想的你加入，一起做点有意思的事。
              </p>
            </div>
          </ScrollReveal>

          {/* Perks */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {perks.map((p, i) => (
              <ScrollReveal key={p.title} delay={i * 80}>
                <div className="h-full border border-gray-100 rounded-2xl p-8 text-center">
                  <div className="w-14 h-14 mx-auto mb-5 rounded-full border border-pink-200 flex items-center justify-center">
                    <i className={`${p.icon} text-2xl text-pink-500`} />
                  </div>
                  <h3 className="text-base font-bold text-gray-900 mb-2">{p.title}</h3>
                  <p className="text-sm text-gray-500 leading-relaxed">{p.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          {/* Positions */}
          <ScrollReveal>
            <h2 className="font-serif text-2xl md:text-3xl font-bold text-gray-900 text-center mb-10">
              热招职位
            </h2>
          </ScrollReveal>
          <div className="border border-gray-100 rounded-2xl overflow-hidden">
            {positions.map((pos, i) => (
              <ScrollReveal key={pos.title} delay={i * 30}>
                <div
                  className={`flex items-center justify-between gap-4 px-6 py-5 hover:bg-pink-50/40 transition-colors ${
                    i !== 0 ? 'border-t border-gray-100' : ''
                  }`}
                >
                  <div className="flex items-center gap-4 min-w-0">
                    <div className="w-10 h-10 rounded-lg bg-pink-50 flex items-center justify-center flex-shrink-0">
                      <i className="ri-briefcase-line text-pink-500" />
                    </div>
                    <div className="min-w-0">
                      <h3 className="text-base font-bold text-gray-900 truncate">{pos.title}</h3>
                      <p className="text-xs text-gray-400 mt-0.5">{pos.dept}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 flex-shrink-0">
                    <span className="px-3 py-1 rounded-full bg-gray-50 border border-gray-100 text-xs text-gray-500 whitespace-nowrap">
                      {pos.type}
                    </span>
                    <span className="text-xs text-gray-400 whitespace-nowrap">{pos.location}</span>
                    <i className="ri-arrow-right-s-line text-gray-300" />
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}